import { Controller } from "@hotwired/stimulus"

// Highlights the current section in the table of contents based on scroll position
export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      { rootMargin: "-80px 0px -70% 0px", threshold: 0 }
    )

    // Observe all sections that have IDs matching our links
    this.linkTargets.forEach((link) => {
      const id = link.getAttribute("href").slice(1)
      const section = document.getElementById(id)
      if (section) {
        this.observer.observe(section)
      }
    })
  }

  disconnect() {
    this.observer.disconnect()
  }

  scrollTo(event) {
    event.preventDefault()
    const id = event.currentTarget.getAttribute("href").slice(1)
    const section = document.getElementById(id)
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" })
      // Update URL without triggering scroll
      history.pushState(null, null, `#${id}`)
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      const link = this.linkTargets.find(
        (l) => l.getAttribute("href") === `#${entry.target.id}`
      )
      if (link) {
        if (entry.isIntersecting) {
          this.linkTargets.forEach((l) => l.classList.remove("active"))
          link.classList.add("active")
        }
      }
    })
  }
}
